import React from "react";
import { Row } from "react-bootstrap";
import { settingsData } from "data";
import { FormattedMessage } from "react-intl";
import SettingsIcon from "assets/svgs/settings.svg";
import ControlArea from "components/Layout/control-area";
import LinkCard from "components/shared/card";

const BlocksTop = () => {
    const topCards = settingsData.map((topcard, index) => (
        <LinkCard cardData={topcard} key={index} />
    ));
    return (
        <div className="topCards">
            <ControlArea
                cardTxt={<FormattedMessage id={"settings"} />}
                icon={SettingsIcon}
            />
            <Row>{topCards}</Row>
        </div>
    );
};

export default BlocksTop;
